const store = () => {
  const setStore = (name, data) => {
    try {
      localStorage.setItem(name, JSON.stringify(data));
    } catch (error) {
      alert('error store');
    }
  };
  const getStore = (name) => {
    const data = localStorage.getItem(name);
    try {
      return JSON.parse(data);
    } catch (error) {
      return null;
    }
  };
  const removeStore = (name) => {
    try {
      localStorage.removeItem(name);
    } catch (error) {
      alert('error store');
    }
  };
  return { getStore, setStore, removeStore };
};

export default store;
